import PropTypes from 'prop-types';
import { useMemo } from 'react';

// material-ui
import { Box, Typography, Tooltip } from '@mui/material';

// third-party
import { formatDuration } from 'date-fns';
import { pt, es, enUS } from 'date-fns/locale';

// project hooks
import useConfig from 'hooks/useConfig';

export const RENDER_DURATION_FORMAT0 = 0;

// ==============================|| RENDER DURATION ||============================== //

const RenderDuration = ({ value, renderFormat = RENDER_DURATION_FORMAT0 }) => {
    const { locale } = useConfig();

    const adapterLocale = useMemo(() => {
        switch (locale) {
            case 'en':
                return enUS;
            case 'es':
                return es;
            default:
                return pt;
        }
    }, [locale]);

    switch (renderFormat) {
        case RENDER_DURATION_FORMAT0:
            return (
                <Tooltip
                    title={
                        <Typography variant="inherit" color="inherit">
                            {formatDuration(
                                { hours: Math.floor(value / 60), minutes: Math.floor(value % 60) },
                                { format: ['hours', 'minutes'], delimiter: ', ', locale: adapterLocale }
                            )}
                        </Typography>
                    }
                >
                    <Typography variant="inherit" color="inherit">
                        {`${Math.floor(value / 60)}:${String(Math.floor(value % 60))
                            .padStart(2, '0')
                            .slice(-2)}`}
                    </Typography>
                </Tooltip>
            );
        default:
            return <Box />;
    }
};

RenderDuration.propTypes = {
    value: PropTypes.object,
    renderFormat: PropTypes.oneOf([RENDER_DURATION_FORMAT0])
};

export default RenderDuration;
